<template>
  <b-table show-empty striped hover class="aco-table"
           :items="organizations" :fields="organizationFields">
    <template slot="empty">
      <div class="text-center">{{ $t('noResults') }}</div>
    </template>
    <template v-slot:cell(show_details)="row">
      <b-button-group>
        <b-button size="md" class="py-0 mr-1" @click.prevent="openOrganizationDetails(row.item)">
          {{ $t('details') }}
        </b-button>
        <b-button size="md" class="py-0 mr-3" v-if="!isActiveProfileSet" v-on:click="updateSessionStorage(row.item.organizationNumber, row.item.name)">
          {{ $t('use') }}
        </b-button>
      </b-button-group>
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrganizationList',
    extends: BaseComponent,
    computed: {
      ...mapGetters('organizations', ['organizations']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet', 'activeProfile']),
      organizationFields () {
        return [
          { key: 'organizationNumber', label: this.$t('organizationNumber') },
          { key: 'name', label: this.$t('organizationName') },
          { key: 'characteristic', label: this.$t('characteristic') },
          { key: 'municipalityName', label: this.$t('municipalityName') },
          { key: 'organizationSource', label: this.$t('source'), formatter: value => this.translateAlternatives('organizationSources', value) },
          { key: 'active', label: this.$t('active'), formatter: 'translateBooleans' },
          { key: 'school', label: this.$t('school'), formatter: 'translateBooleans' },
          { key: 'schoolOwner', label: this.$t('schoolOwner'), formatter: 'translateBooleans' },
          { key: 'departments', label: 'Avdelinger', formatter: (value) => (value || []).length },
          { key: 'show_details', label: '' }
        ]
      }
    },
    created: function () {
      this.$store.dispatch('organizations/getOrganizations')
      this.$store.dispatch('sessionStorage/checkSessionStorage')
    },
    methods: {
      updateSessionStorage (id, name) {
        let sessionStorageRequest = {
          activeProfileType: 'organization',
          id: id,
          name: name
        }
        this.$store.dispatch('sessionStorage/updateSessionStorage', sessionStorageRequest)
        this.$router.push('/licenses')
      },
      openOrganizationDetails(organization) {
        this.$router.push({ name: 'OrganizationDetails', params: { id: organization.organizationNumber }})
      },
    }
  }
</script>
